import { CalendarDate, now, toCalendarDate } from '@internationalized/date';
import { useState } from 'react';

import Stack from '../../../Stack/Stack';
import MonthCalendar from '../MonthCalendar/MonthCalendar';
import YearSlider from '../YearSlider/YearSlider';

type MonthViewProps = {
    value?: CalendarDate | null;
    defaultFocusedDate?: CalendarDate;
    onChange: (focusDate: CalendarDate) => void;
    timeZone: string;
    minValue?: CalendarDate;
    maxValue?: CalendarDate;
};

const MonthView = ({
    value,
    defaultFocusedDate,
    onChange,
    timeZone,
    minValue,
    maxValue,
}: MonthViewProps) => {
    const [focusDate, setFocusDate] = useState<CalendarDate>(
        defaultFocusedDate ?? toCalendarDate(now(timeZone))
    );

    return (
        <Stack space="large-plus">
            <YearSlider
                timeZone={timeZone}
                onChange={setFocusDate}
                focusDate={focusDate}
                minValue={minValue}
                maxValue={maxValue}
            />

            <MonthCalendar
                focusedDate={focusDate}
                value={value}
                onChange={(newValue) => {
                    onChange?.(newValue.set({ year: focusDate.year }));
                }}
                timeZone={timeZone}
                minValue={minValue}
                maxValue={maxValue}
            />
        </Stack>
    );
};

export default MonthView;
